/** method to save workbook as xlsx file
 * @param {string} fileName
 * @param {import('exceljs').Workbook} workbook
 */
export const saveFileAsXlsx = async (
  fileName: string,
  workbook: import('exceljs').Workbook
) => {
  const xls64 = await workbook.xlsx.writeBuffer({ base64: true } as any);
  await require('file-saver').saveAs(
    new Blob([xls64], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    fileName
  );
};

/** method to save workbook as csv file
 * @param {string} fileName
 * @param {import('exceljs').Workbook} workbook
 * @param {string} [delimiter]
 */
export const saveFileAsCsv = async (
  fileName: string,
  workbook: import('exceljs').Workbook,
  delimiter = ','
) => {
  const xls64 = await workbook.csv.writeBuffer({
    formatterOptions: { delimiter },
  });

  await require('file-saver').saveAs(
    new Blob([xls64], {
      type: 'text/csv',
    }),
    fileName
  );
};
